var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-bb-brand-purple flex items-center gap-2 cursor-pointer mx-6",class:{ 'opacity-50 pointer-events-none': _vm.isLoading },on:{"click":_vm.updateCampaignList}},[_c('ic-refresh'),_c('p',{staticClass:"font-medium"},[_vm._v("Update Campaign List")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }